import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import i18n from './i18n/i18n';

// Import CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';

// Import Layout and Pages
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage'; // <-- IMPORT THE NEW PAGE
import ContactPage from './pages/ContactPage'; // <-- IMPORT THE NEW PAGE
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage'; // <-- Import the new placeholder page



function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/pricing" element={<PricingPage />} /> {/* <-- ADD THIS NEW ROUTE */}
            <Route path="/contact" element={<ContactPage />} /> {/* <-- ADD THIS NEW ROUTE */}
            <Route path="/login" element={<LoginPage />} /> {/* <-- ADD THIS NEW ROUTE */}
            <Route path="/register" element={<RegisterPage />} /> {/* <-- ADD THE REGISTER ROUTE */}

            {/* Add other routes like /services, /contact here in the future */}
          </Route>
        </Routes>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;